<script>
export default {
  name: "settingRoleIcon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12 12.5733H11.4933C10.96 12.5733 10.4533 12.78 10.08 13.1533L8.93998 14.28C8.41998 14.7933 7.57334 14.7933 7.05334 14.28L5.91333 13.1533C5.54 12.78 5.02667 12.5733 4.5 12.5733H4C2.89333 12.5733 2 11.6867 2 10.5934V3.32001C2 2.22667 2.89333 1.34003 4 1.34003H12C13.1067 1.34003 14 2.22667 14 3.32001V10.5934C14 11.68 13.1067 12.5733 12 12.5733Z"
      stroke="#A2A5B9"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.00061 6.66665C8.85849 6.66665 9.55396 5.97118 9.55396 5.1133C9.55396 4.25542 8.85849 3.56 8.00061 3.56C7.14273 3.56 6.44727 4.25542 6.44727 5.1133C6.44727 5.97118 7.14273 6.66665 8.00061 6.66665Z"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.6673 10.44C10.6673 9.23996 9.47398 8.26666 8.00065 8.26666C6.52732 8.26666 5.33398 9.23996 5.33398 10.44"
      stroke="#A2A5B9"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped></style>
